module.exports = __webpack_public_path__ + "img/nos-logo.f74f3ac2.png";